export enum InviteStatus {
  Sent,
  Accepted,
  Denied,
}
